export interface VendorInheritance {
    isInheritingChild: boolean;
    parentCompanyName: string | null;
}

export const defaultVendorInheritance: VendorInheritance = {
    isInheritingChild: false,
    parentCompanyName: null,
};

/**
 * Normalises the `vendorInheritance` block from GET /session. The block is absent on older
 * WebAPI builds and the unauthenticated session, and `status: "unknown"` means the API could not
 * resolve it, so anything other than `settingEnabled === true && isInheritingChild === true` is treated as not inheriting.
 */
export const normalizeVendorInheritance = (
    block?: {
        isInheritingChild?: boolean | null;
        settingEnabled?: boolean | null;
        parentCompanyName?: string | null;
    } | null
): VendorInheritance => ({
    // Restrictions apply only when the account setting is on AND the company is an inheriting child.
    isInheritingChild: block?.isInheritingChild === true && block?.settingEnabled === true,
    parentCompanyName: block?.parentCompanyName ?? null,
});

/** A vendor is read-only (a parent vendor, shown with the "Inherited" badge) when search/get-by-id says it is not editable. `null`/missing means editable. */
export const isVendorReadOnly = (vendor?: { isEditable?: boolean | null } | null): boolean =>
    vendor?.isEditable === false;

/** True when any linked vendor is read-only, e.g. the vendors on a vendor certificate. */
export const hasReadOnlyVendor = (
    vendors?: Array<{ isEditable?: boolean | null }> | null
): boolean => Array.isArray(vendors) && vendors.some(isVendorReadOnly);
